function VirtualPhotobooth() {
  return (
    <section id="virtual-photobooth" className="photobooth-section">
      <h2>Virtual Photobooth</h2>
      <p>Abadikan momen spesialmu dengan Virtual Photobooth MomenQ, nikmati pengalaman interaktif yang bisa langsung disimpan, dibagikan, dan dikenang selamanya.</p>

      <div className="photobooth-features">
        <div className="feature-card">
          {/* <img src="https://images.unsplash.com/photo-1519744792095-2f2205e87b6f?auto=format&fit=crop&w=400&q=80" alt="Filter Kreatif" /> */}
          <h3>Bingkai Kustom</h3>
          <p>Sesuaikan bingkai dengan keinginanmu agar momen lebih berkesan.</p>
        </div>

        <div className="feature-card">
          {/* <img src="https://images.unsplash.com/photo-1519744792095-2f2205e87b6f?auto=format&fit=crop&w=400&q=80" alt="Filter Kreatif" /> */}
          <h3>Pesan Suara</h3>
          <p>Kumpulkan pesan suara penuh makna berisi cinta dan doa dari para tamu.</p>
        </div>

        <div className="feature-card">
          {/* <img src="https://images.unsplash.com/photo-1554224154-22dec7ec8818?auto=format&fit=crop&w=400&q=80" alt="Download Langsung" /> */}
          <h3>Unduh & Bagikan</h3>
          <p>Foto yang diambil bisa langsung diunduh untuk disimpan atau dibagikan.</p>
        </div>

        <div className="feature-card">
          {/* <img src="https://images.unsplash.com/photo-1584650296364-2e02e2f4e3c7?auto=format&fit=crop&w=400&q=80" alt="Bagikan Media Sosial" /> */}
          <h3>Galeri</h3>
          <p>Semua foto dan pesan suara secara otomatis dikumpulkan dalam satu galeri.</p>
        </div>
      </div>

      {/* <a href="#packages" className="cta-button">Pesan Sekarang</a> */}
    </section>
  );
}

export default VirtualPhotobooth;
